import { toASCII } from 'punycode';
import { validTLDsList } from './validTLDsList';

/* Realiza a validação com o algoritmo oficial da Receita Federal do Brasil */
/* Fonte: https://www.geradorcpf.com/javascript-validar-cpf.htm */
export const validateCpf = (cpf: string) => {
  if (cpf === '' || !cpf) return false;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }

  // Validate 1º digit
  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rev = 11 - (add % 11);

  if (rev === 10 || rev === 11) {
    rev = 0;
  }

  if (rev !== parseInt(cpf.charAt(9))) {
    return false;
  }

  // Validate 2ª digit
  add = 0;
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }

  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }

  if (rev !== parseInt(cpf.charAt(10))) {
    return false;
  }

  return true;
};

export const validatePhone = (value: string) => {
  const regex = /[1-9]\d9?\d{4}\d{4}/g;
  return regex.test(value);
};

export const validateURL = (str: string) => {
  if (str === '') {
    return true;
  }
  let pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return !!pattern.test(str);
};

const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,}$/;

const validateEmailPattern = (value?: string) => {
  return !!value && !!toASCII(value).match(emailRegex);
};

const validateEmailTLD = (value?: string) => {
  if (!value) {
    return false;
  }

  const tldEmail = value.split('.').pop();
  return new Set(validTLDsList).has(`.${tldEmail?.toLowerCase()}`);
};

export const validateEmail = (value?: string) => {
  return validateEmailPattern(value) && validateEmailTLD(value);
};
